<div class="modal-header-icon-container">
    <ion-icon [icon]="icon"></ion-icon>
</div>